// extracted by mini-css-extract-plugin
export default {"inputBox":"InputBox_inputBox__1cJ2-","input":"InputBox_input__7mY-i"};